'use strict';

import $ from 'jquery';
import axios from 'axios';
import moment from 'moment-timezone';
import BarMessage from '../bar-message';
import countdown from 'countdown';
import requestFrame from 'request-frame';
import clock from './svg/clock.svg';
import Modal from './modal';
import { inShopifyCartPage } from '../../utilities';
import { prettyTableContent, prettyMessage, itemDateTimeFormat, prettyTime } from './parser';
import { findStartDateTime, findFinishDateTime, findUnits } from './finder';
import './index.css';

moment.fn.countdown = function() {
  let other, args
  const slice = [].slice
  other = arguments[0], args = 2 <= arguments.length ? slice.call(arguments, 1) : [];
  return countdown.apply(null, [this.toDate(), moment(other).toDate()].concat(slice.call(args)));
};

export default class Index {
  constructor(sdk, options = {}) {
    const self = this
    this.fetchCart(() => {
      self.target = [
        'form[action="/cart/add"] button[type="submit"]',
        'form[action="/cart/add"] input[type="submit"]',
        '.add-to-cart'
      ].concat(options.widgets_target && options.widgets_target.cart_check || []);

      self.options = Object.assign({
        dateFormat: 'MM/DD/YYYY',
        countdown: true,
        barMode: false,
        expiredActions: 'disable',
        callbacks: {
          confirmed: self.onConfirmed.bind(self),
          failed: self.onFailed.bind(self)
        }
      }, options);
      self.cartForm = $('form[action="/cart"]');
      self.checkEnvironment();
      self.attachListeners();
      self.btaSdk = sdk;
      self.reserveCart(self.options.callbacks)
    });
  }

  fetchCart(callback) {
    const self = this
    return axios.get('/cart.js')
                .then(({data}) => self.cart = data)
                .then(() => callback())
  }

  checkEnvironment() {
    if ($('#booking-status').length == 0) {
      this.options.barMode = true
      const modal = new Modal('Reservation')
      this.modal = modal;
      this.barMessage = new BarMessage({
        id: 'bta-cart-to-reservation',
        onHide() {
          modal.hide()
        }
      });
    }
  }

  attachListeners() {
    const self = this
    this.cartForm.on('click', ':submit[name="checkout"]', e => this.handleSubmitClick(e));

    // hide modal & barMessage when click others place
    document.addEventListener('click', e => {
      if (
        self.options.barMode &&
        (e.target !== self.barMessage.bar && e.target.contains(self.barMessage.bar) ||
         e.target !== self.modal.body && e.target.contains(self.modal.body))
      ) {
        self.modal.hide()
        self.barMessage.hide()
      }
    })

    $(this.target.join(',')).on('click', e => {
      self.fetchCart(() => self.reserveCart(self.options.callbacks));
      if (self.options.barMode) {
        self.modal.hide()
        self.barMessage.show()
      }
    });
  }

  handleSubmitClick(e) {
    e.preventDefault();
    const self   = this,
          button = $(e.target);

    self.reserveCart({
      confirmed() {
        self.enableCheckout(true)
        self.cartForm.off('click', ':submit[name="checkout"]');
        button[0].click();
      },
      failed(reservation) {
        self.showErrors(reservation);
      }
    });

    return false;
  }

  reserveCart(callbacks) {
    let items = [];

    for (let i = 0; i < this.cart.items.length; i++) {
      let item            = this.cart.items[i],
          start           = findStartDateTime(item.properties, this.options.dateFormat),
          finish          = findFinishDateTime(item.properties, this.options.dateFormat),
          reservationItem = {
            product_title: item.product_title,
            external_id: item.variant_id,
            quantity: findUnits(item),
            status: 'ok'
          }

      if (start) {
        reservationItem.start = start;

        if (finish) {
          reservationItem.finish = finish;
        }

        items.push(reservationItem);
      }
    }

    this.btaSdk.createReservation({cart_token: this.cart.token, items: items})
        .then(result => {
          if (items.length) {
            this.handleReservation(result.data.reservation, callbacks)
            this.options.barMode && this.barMessage.show()
          } else {
            callbacks.confirmed && callbacks.confirmed()
            if (this.options.barMode) {
              this.barMessage.hide()
              this.modal.hide()
            }
          }
        })
        .catch(response => {
          let error

          if (response.response) {
            error = response.response

            if (error.status === 401) {
              callbacks.confirmed && callbacks.confirmed()
            } else {
              items = this.dealErrorItems(items, error)
              this.showErrors({items, tz: error.data.tz})
            }

          } else {
            // show message if js function broken
            throw(response)
          }
        });
  }

  dealErrorItems(items, error) {
    if (error.data.items) {
      // on_invalid
      error.data.items.forEach(item => {
        let index   = item.match(/\[(\d+)\]/)[1],
            message = item.match(/items\[\d+\]\[[^\[]+\]: \[\"(.+)\"\]/)[1]

        items[index].status = prettyTime(message, error.data.tz)
      })
    } else {
      // on_failed
      error.data.errors.forEach(errors => {
        const item = items.find(item => item.external_id === errors.external_id)
        item.status = errors.messages.join(', ')
      })
    }
    return items
  }

  handleReservation(reservation, callbacks) {
    this.currentReservation = reservation;

    let reservationStatusOk = true;
    for (let x = 0; x < reservation.items.length; x++) {
      if (reservation.items[x].status !== 'ok') {
        reservationStatusOk = false;
        break;
      }
    }

    if (reservationStatusOk) {
      callbacks.confirmed && callbacks.confirmed(reservation);
    } else {
      callbacks.failed && callbacks.failed(reservation);
    }
  }

  onConfirmed(reservation) {
    if (reservation) {
      this.updateConfirmedStatus(reservation);
    }
    this.enableCheckout(true);
  }

  onFailed(reservation) {
    this.showErrors(reservation);
  }

  onExpired() {
    if (this.options.barMode) {
      this.barMessage.showInfo('<p>Your reservation has expired. Please remove the items and add them again.</p>')
    } else {
      $('#booking-status').html('<p>Your reservation has expired. Please remove the items and add them again.</p>')
    }

    let actions = (this.options.expiredActions || '').toLowerCase().split(',');
    for (let i = 0; i < actions.length; i++) {
      switch(actions[i]) {
        case 'disable':
          this.enableCheckout(false);
          break;
      }
    }

    this.options.callbacks.expired && this.options.callbacks.expired(this.currentReservation);
  }

  enableCheckout(enabled) {
    this.cartForm.find(':submit[name="checkout"], button[name="checkout"]').prop('disabled', !enabled);
  }

  updateConfirmedStatus(reservation) {
    let expiry = moment(reservation.expires_at),
        msg    = `Your booking is reserved until <time datetime="${moment(expiry).utc().toISOString()}">${expiry.format(itemDateTimeFormat())}</time>`

    if (this.options.countdown) {
      if (this.options.barMode) {
        this.barMessage.updateCountDown(`${clock} ${moment().countdown(expiry).toString()}`)
      } else {
        msg += `&nbsp;<span class="countdown">(${moment().countdown(expiry).toString()} from now)</span>`
      }
    }
    if (this.options.barMode) {
      this.barMessage.showInfo(`<p>${msg}</p>`)
      this.modal.hide()
    } else {
      $('#booking-status').html(`<p>${msg}</p>`);
    }

    if (this.options.countdown) {
      this.updateExpiryCountdown();
    }
  }

  updateExpiryCountdown() {
    let countdown = $('#booking-status .countdown, #bta-cart-to-reservation .countdown'),
        expiry    = moment($('#booking-status time').attr('datetime')),
        timespan  = moment().countdown(expiry);

    if (timespan.value > 0) {
      if (this.options.barMode) {
        timespan.toString()
        this.barMessage.updateCountDown(`${clock} ${moment(timespan.value).format('mm:ss')}`)
      } else {
        countdown.html(`(${timespan.toString()} from now)`);
      }

      // polyfill for requestAnimationFrame
      requestFrame('request')(this.updateExpiryCountdown.bind(this), countdown.get(0).parentNode)

    } else {
      this.onExpired();
    }
  }

  showErrors(reservation) {
    if (this.options.barMode) {
      const button = document.createElement('button'),
            html   = `<p>Booking could not be reserved.</p>`

      button.innerHTML = 'UPDATE RESERVATION'
      button.classList.add('bta-update-reservation')
      button.onclick = this.renderModal.bind(this, reservation)

      this.barMessage.showInfo(html)
      document.querySelector('#booking-status p').append(button)

      if (this.modal.isShow()) this.renderModal(reservation)

      this.barMessage.show()

    } else {
      $('#booking-status').html(prettyMessage(reservation));
    }
  }

  renderModal(reservation) {
    const div = document.createElement('div')
    div.style.cssText = `overflow: scroll;`
    div.innerHTML = `<p>Please remove the item and add it again using an available time.</p>`
    div.append(prettyTableContent(reservation, item => this.removeItem(item)))
    this.modal.render(div)
  }

  removeItem(item) {
    const self = this
    axios.post(`/cart/change.js?quantity=0&id=${item.external_id}`)
         .then(({data}) => {
           if (inShopifyCartPage()) {
             location.reload()
           } else {
             self.cart = data
             self.reserveCart(self.options.callbacks)
           }
         })
  }

  setTime(date, time) {
    return date.hour(time.hour()).minute(time.minute());
  }
}
